import { render, staticRenderFns } from "./editPublicity.vue?vue&type=template&id=5a8911a4&scoped=true"
import script from "./editPublicity.vue?vue&type=script&lang=js"
export * from "./editPublicity.vue?vue&type=script&lang=js"
import style0 from "./editPublicity.vue?vue&type=style&index=0&id=5a8911a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8911a4",
  null
  
)

export default component.exports